/* Keep the native app's product form present while the preparation gate is closed.
 * Draft product status and password protection remain separate server controls.
 */
// Several sizes share one personalized design: the shown price follows the selected size.
function everliltSyncPrice(select) {
  const option = select.options[select.selectedIndex];
  const price = select.closest('.mf').querySelector('[data-everlilt-price]');
  if (option && price && option.dataset.price) price.textContent = option.dataset.price;
}
document.addEventListener('change', function (event) {
  if (event.target.matches('select[data-everlilt-variants]')) everliltSyncPrice(event.target);
});
// Browsers may restore a previous size on reload or back navigation without firing change.
window.addEventListener('pageshow', function () {
  document.querySelectorAll('select[data-everlilt-variants]').forEach(everliltSyncPrice);
});
document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!form.matches('form[data-everlilt-ordering]')) return;
  if (form.dataset.everliltOrdering !== 'true') {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  // The native app inserts this reference only after Save design. It is a
  // reference, not proof that the buyer replaced every placeholder or that
  // Printify has validated a production file. Those checks belong downstream.
  const reference = form.querySelector('input[name="properties[Personalization ID]"]');
  const missing = !reference || reference.disabled || !reference.value.trim();
  const message = form.querySelector('[data-everlilt-personalization-error]');
  if (message) message.hidden = !missing;
  if (missing) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (message) message.focus();
  }
}, true);
